/**
 * @generated SignedSource<<0b55695b8b7de297b5b4340e4fae0479>>
 * @relayHash e39e74a2061c74e93a6c8d5ab6295865
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e39e74a2061c74e93a6c8d5ab6295865

import { ConcreteRequest } from 'relay-runtime';
export type ChMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE" | "TEMPLATE";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
export type Ch_createRecommendedMedicationInput = {
  medicationId: string;
  patientId: string;
  progressNoteId: string;
};
export type chCreateRecommendedMedicationMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_createRecommendedMedicationInput;
};
export type chCreateRecommendedMedicationMutation$data = {
  readonly chCreateRecommendedMedication: {
    readonly ch_RecommendedMedication: {
      readonly id: string;
      readonly medication: {
        readonly __typename: "ch_Medication";
        readonly createdAt: string;
        readonly createdBy: string;
        readonly endDate: any | null;
        readonly eveningDosage: number;
        readonly id: string;
        readonly internalNotes: string | null;
        readonly isPermanentPrescription: boolean;
        readonly morningDosage: number;
        readonly name: string;
        readonly nightDosage: number;
        readonly noonDosage: number;
        readonly numberOfPackages: number;
        readonly packageSize: string | null;
        readonly patientId: string;
        readonly pharmaCode: number | null;
        readonly productUrl: any | null;
        readonly refuseSubstitutes: boolean;
        readonly startDate: any | null;
        readonly templateCategory: string | null;
        readonly templateId: number | null;
        readonly type: ChMedicationType;
        readonly unit: MedicationUnit;
        readonly updatedAt: string | null;
        readonly updatedBy: string | null;
        readonly usageInstructions: string | null;
      };
      readonly medicationId: number;
      readonly patientId: string;
      readonly progressNoteId: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chCreateRecommendedMedicationMutation = {
  response: chCreateRecommendedMedicationMutation$data;
  variables: chCreateRecommendedMedicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_RecommendedMedication",
  "kind": "LinkedField",
  "name": "ch_RecommendedMedication",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_Medication",
      "kind": "LinkedField",
      "name": "medication",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pharmaCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "morningDosage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noonDosage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eveningDosage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nightDosage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usageInstructions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "internalNotes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateCategory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "packageSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "refuseSubstitutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfPackages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPermanentPrescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medicationId",
      "storageKey": null
    },
    (v5/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chCreateRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "chCreateRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_createRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "ch_createRecommendedMedication",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chCreateRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "chCreateRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_createRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "ch_createRecommendedMedication",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "ch_RecommendedMedication",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ch_ProgressNoteEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e39e74a2061c74e93a6c8d5ab6295865",
    "metadata": {},
    "name": "chCreateRecommendedMedicationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4849c2cbeef0bf10793d55a9c05696ca";

export default node;
